import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import servicesData from '../data/servicesData';
import { handleLinkClick } from '../utils/deviceUtils';
import { getIconForService } from '../components/ServiceIcons';
import '../styles/ServiceDetail.css';

const ServiceDetailPage = () => {
    const { serviceSlug } = useParams();
    const service = servicesData.find(s => s.slug === serviceSlug);

    useEffect(() => {
        document.title = `${service.title} | Datamatics Consulting`;
    }, [service]);

    if (!service) {
        return <div className="not-found-service">Service not found</div>;
    }

    return (
        <div className="service-detail-page-service">

            {/* Main Service Heading + Description */}
            <section className="service-hero-section-service">
                <div className="container">
                    <div className="service-header-service">
                        <div className="service-label-row">
                            <span className="service-label-line"></span>
                            <p className="service-label-text">{service.title}</p>
                        </div>
                        <p className="service-description-service">
                            {service.description}
                        </p>
                    </div>
                </div>
            </section>

            {/* Sub Services Cards */}
            <section className="expertise-section-service">
                <div className="container">
                    <div className="expertise-grid">
                        {service.subServices.map((sub, index) => {
                            const subSlug = sub.title
                                .toLowerCase()
                                .replace(/\s+/g, '-')
                                .replace(/,/g, '')
                                .replace(/&/g, 'and')
                                .replace(/[()]/g, '');

                            const fullLink = `/services/${service.slug}/${subSlug}`;
                            return (
                                <div key={index} className="expertise-card service-subservice-card">
                                    <div className="card-content service-card-content">
                                        <div className="card-icon">
                                            {React.createElement(getIconForService(index, sub.slug))}
                                        </div>
                                        <h3 className="card-title service-card-title">{sub.title}</h3>
                                    </div>
                                    <div className="card-hover-overlay-service service-card-hover-overlay">
                                        <h3 className="service-card-title">{sub.title}</h3><br></br>
                                        <p className="service-card-description">{sub.description}</p>
                                        <a
                                            href={fullLink}
                                            className="card-btn service-card-btn"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleLinkClick(fullLink);
                                            }}
                                        >
                                            Learn More
                                        </a>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ServiceDetailPage;